<template>
  <div class="row">
    <div class="col-sm-12 col-md-12">
      <b-container fluid>
        <b-row class="my-1">
          <b-col sm="12">
            <label>Title:</label>
          </b-col>
          <b-col sm="12">
            <b-form-input id="input-small" v-model="form.title" size="sm" placeholder="Enter title"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="12" class="ml-0">
            <label>Description:</label>
          </b-col>
          <b-col sm="12">
            <b-form-textarea id="input-small" v-model="form.description" size="sm" placeholder="Enter description"></b-form-textarea>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="12" class="ml-0">
            <label>Modifier Group Type:</label>
          </b-col>
          <b-col sm="12">
            <b-form-select v-model="form.is_variant">
              <option :value="1">Variant</option>
              <option :value="0">Add on</option>
            </b-form-select>
          </b-col>
        </b-row>
        <b-row class="my-1" v-if="form.is_variant == 0">
          <b-col sm="6">
            <label>Min Selectable:</label>
            <b-form-input type="number" min="0" v-model="form.min_selectable" id="input-small" size="sm" placeholder="Min Selectable"></b-form-input>
          </b-col>
          <b-col sm="6">
            <label>Max Selectable:</label>
            <b-form-input type="number" min="0" v-model="form.max_selectable" id="input-small" size="sm" placeholder="Min Selectable"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="6">
            <label>Sort Order:</label>
            <b-form-input type="number" min="0" v-model="form.sort_order" id="input-small" size="sm" placeholder="Sort Order"></b-form-input>
          </b-col>
          <b-col sm="6">
            <label>Display Inline (Urban Piper):</label>
            <b-form-checkbox switch v-model="form.display_inline" name="check-button" size="sm"></b-form-checkbox>
          </b-col>
          <b-col sm="12">
            <label>Store</label>
            <select-with-search :merge_display="['ref_id','name']" :multi_select="true" :search_api="StorePath.SEARCH_STORE" track_by="id" display="name" @selectedOption="((v) => form.selected_store = v)"></select-with-search>
          </b-col>
        </b-row>
        <b-row class="my-1 mt-2">
          <b-col sm="12">
            <b-button @click="saveOpg" class="btn btn-success">Submit</b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {OpsPath,StorePath} from "../../../../path";
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch.vue";
export default {
  name: "add",
  props : ['selected_op_g'],
  components : {SelectWithSearch},
  data(){
    return {
      form : {
        display_inline : false,
        is_variant : false
      },
      baseUrl : process.env.VUE_APP_API_BACKEND_URL,
      filters : [],
    }
  },
  watch : {
    selected_op_g: {
      deep : true,
      handler(v){
        console.log(v);
        this.form = v;
      }
    }
  },
  computed : {
    StorePath(){
      return StorePath;
    }
  },
  mounted() {
    if(this.selected_op_g){
      this.form = this.selected_op_g;
    }
  },
  methods : {
    async saveOpg(){
      try {
        let res = await axios.post(this.baseUrl + OpsPath.SAVEOPGS,this.form);
        if(res.data.status == true)
        {
          this.$bvToast.toast('Successfully added', {
            title: `Modifier Group added`,
            variant: 'success',
            solid: true
          });
          this.$bvModal.hide("bv-add-options-group");
          this.$emit("update");
        }
      }catch (e) {
        console.log(e);
      }
    }
  }
}
</script>

<style scoped>

</style>